import { getAuthenticityToken } from './dom';

/**
 * OmniAuth only accepts a POST with a CSRF token to start the sign-in flow, so submit a hidden form.
 */
export function initiateOmniauthFlow(): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `/u/auth/${GLOBALS.config.omniauthProvider}`;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'authenticity_token';
  input.value = getAuthenticityToken() ?? 'missing';
  form.appendChild(input);

  document.body.appendChild(form);
  form.submit();
}
